import React from "react";

// A friendly child guide from the logo family, shown in a soft circular badge.
// mascots are light-background illustrations, so a white/tinted badge blends cleanly.
export const GuideMascot = ({
  src,
  alt = "Friendly guide",
  size = 128,
  ring = "#FFD166",
  badge = "#ffffff",
  float = "animate-floaty",
  className = "",
  flip = false,
}) => {
  return (
    <div
      className={`relative shrink-0 ${float} ${className}`}
      style={{ width: size, height: size }}
      data-testid="guide-mascot"
    >
      <div
        className="w-full h-full rounded-full overflow-hidden shadow-soft-sm grid place-items-center"
        style={{ background: badge, border: `4px solid ${ring}` }}
      >
        <img
          src={src}
          alt={alt}
          loading="lazy"
          className="w-[86%] h-[86%] object-contain"
          style={{ transform: flip ? "scaleX(-1)" : "none" }}
          draggable={false}
        />
      </div>
    </div>
  );
};

// A guide with a small speech bubble note
export const GuideWithNote = ({ src, note, ring, size = 120, flip = false, side = "right" }) => {
  return (
    <div className={`flex items-center gap-4 ${side === "left" ? "flex-row-reverse" : ""}`}>
      <GuideMascot src={src} size={size} ring={ring} flip={flip} />
      <div className="relative max-w-xs bg-white rounded-2xl px-5 py-3 shadow-soft-sm border border-black/5">
        <p className="font-hand text-2xl leading-snug text-[#1E293B]">{note}</p>
      </div>
    </div>
  );
};

export default GuideMascot;
